export enum AuthPathEnum {
  Auth = 'auth',
  Home = 'home',
  Signup = 'signup',
  Signup_Verify = 'signup-verify',
  Forget_Password = 'forget-password',
  Forget_Password_Verify = 'forget-verify',
  Dashboard = 'dashboard',
  Initializing = 'initializing',

}
